import { Loader2 } from "lucide-react";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface SpinProps extends React.HTMLAttributes<HTMLDivElement> {
	spinning?: boolean;
	tip?: React.ReactNode;
	size?: "small" | "default" | "large";
	children?: React.ReactNode;
}

const Spin = forwardRef<HTMLDivElement, SpinProps>(
	({ className, spinning = true, tip, size = "default", children, ...props }, ref) => {
		const sizeStyles = {
			small: "h-4 w-4",
			default: "h-6 w-6",
			large: "h-8 w-8",
		};

		const spinElement = (
			<div
				ref={ref}
				className={cn("inline-flex flex-col items-center justify-center gap-2", className)}
				{...props}
			>
				<Loader2 className={cn("animate-spin text-primary-500", sizeStyles[size])} />
				{tip && <span className="text-sm text-gray-500 dark:text-gray-400">{tip}</span>}
			</div>
		);

		if (children) {
			return (
				<div className="relative">
					{spinning && (
						<div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 dark:bg-gray-900/70">
							{spinElement}
						</div>
					)}
					<div className={cn(spinning && "opacity-50 pointer-events-none")}>{children}</div>
				</div>
			);
		}

		return spinning ? spinElement : null;
	},
);

Spin.displayName = "Spin";

export { Spin };
